module.exports = __webpack_public_path__ + "static/media/ill_muskelochledbesvar.d7a6ea10.svg";